/**
 * 案件詳細画面内契約タブ用Form定義ファイル
 * 概要
 *  案件詳細画面内契約タブ用のForm定義をまとめたファイル
 * 更新履歴
 *  2022/03/03 新規 小林
 */
import { FieldChildrenProp } from '@/services/hexabase/types';

/* eslint-disable @typescript-eslint/camelcase */
/*
export const SignatureRequestRules = [
  {
    id: 'id',
    rule: ['is_uniq_account']
  },
  {
    id: 'email',
    rule: ['email']
  },
  {
    id: 'u_id',
    rule: ['is_uniq_account']
  }
];
*/

export const FileUploadItemForm = [
/*  
  {
    // インタフェース利用のために必要なプロパティ、画面では未使用
    'search': false,
    'show_list': false,
    'as_title': false,
    'status': false,
    'fieldIndex': 1,
    'title_order': 1,
    'full_text': false,
    'unique': false,
    'min_value': '',
    'max_value': '',
    // ****** //
    'field_id': '契約書タイプ',
    'name': 'contractType',
    'display_id': 'contractType',
    'dataType': 'select',
    'component': 'SelectArea',
    'props': {
      'name': 'contractType',
      'label': '契約書タイプ',
      'selectData': [],
      'isDisabled': true,
      rules: 'selectRequired',
    },
    'sizeX':2,
    'sizeY':1,
    'col':0,
    'row':0,
    'show': true,
  },
*/  
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'document_name',
    name: 'document_name',
    display_id: 'document_name',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '文書名',
      labelText: '文書名',
      name: 'document_name',
      isReadonly: true,
      isDisabled: true,
      rules: 'required',
      value: '',
      placeholder: '64文字以内',
      maxlength: 64
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'post_nm',
    name: 'post_nm',
    display_id: 'post_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信者部署名',
      labelText: '送信者部署名',
      name: 'post_nm',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
      placeholder: '50文字以内',
      maxlength: 50
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'name_nm',
    name: 'name_nm',
    display_id: 'name_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信者名',
      labelText: '送信者名',
      name: 'name_nm',
      isReadonly: true,
      isDisabled: true,
      rules: 'required',
      value: '',
      placeholder: '50文字以内',
      maxlength: 50
    },
    sizeX: 1,
    sizeY: 1,
    col: 2,
    row: 1,
    show: true
  },
/*  
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    field_id: 'simwork_email',
    name: 'simwork_email',
    display_id: 'simwork_email',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信者メールアドレス',
      labelText: '送信者メールアドレス',
      name: 'simwork_email',
      isReadonly: true,
      isDisabled: true,
      rules: 'required|email',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  },
*/  
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'complete_email',
    name: 'complete_email',
    display_id: 'complete_email',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '完了通知メールアドレス',
      labelText: '完了通知メールアドレス',
      name: 'complete_email',
      isReadonly: true,
      isDisabled: true,
      rules: 'email',
      value: '',
      maxlength: 255
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 2,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'conclusion_date',
    name: 'conclusion_date',
    dataType: 'datetime',
    display_id: 'conclusion_date',
    component: 'DatePickerArea',
    props:{
      labelClass: 'mb-2',
      'format': 'yyyy/MM/dd',
      'labelName':'契約開始日',
      'labelText':'契約開始日',
      'name':'conclusion_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': '',
      'minDate': '1900/01/01',
      'maxDate': '2100/12/31',
      placeholder: 'YYYY/MM/DD'
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 3,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'agreement_start_date',
    name: 'agreement_start_date',
    dataType: 'datetime',
    display_id: 'agreement_start_date',
    component: 'DatePickerArea',
    props:{
      labelClass: 'mb-2',
      'format': 'yyyy/MM/dd',
      'labelName':'契約終了日',
      'labelText':'契約終了日',
      'name':'agreement_start_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': '',
      'minDate': '1900/01/01',
      'maxDate': '2100/12/31',
      placeholder: 'YYYY/MM/DD'
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 3,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'agreement_end_date',
    name: 'agreement_end_date',
    dataType: 'datetime',
    display_id: 'agreement_end_date',
    component: 'DatePickerArea',
    props:{
      'format': 'yyyy/MM/dd',
      labelClass: 'mb-2',
      'labelName':'契約締結日',
      'labelText':'契約締結日',
      'name':'agreement_end_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': '',
      'minDate': '1900/01/01',
      'maxDate': '2100/12/31',
      placeholder: 'YYYY/MM/DD'
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 4,
    show: true
  },
/*  
  {
    // インタフェース利用のために必要なプロパティ、画面では未使用
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'contract_amount',
    name: 'contract_amount',
    display_id: 'contract_amount',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '契約金額',
      labelText: '契約金額',
      name: 'contract_amount',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
      maxlength: 10, 
      max: 9999999999,
      min: 0
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: true
  },
*/  
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'long_storage',
    name: 'long_storage',
    display_id: 'long_storage',
    dataType: 'text',
    component: 'CheckBox',
    props: {
      checkBoxs: [{
        name: 'long_storage',
        text: '長期保存チェック',
        default: false,
        addClass: 'checkbox-fontsize',
      }],
      checkStatus: {long_storage: false},
      isDisabled: true
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'matter_status_update_flag',
    name: 'matter_status_update_flag',
    display_id: 'matter_status_update_flag',
    dataType: 'text',
    component: 'CheckBox',
    props: {
      checkBoxs: [{
        name: 'matter_status_update_flag',
        text: 'この契約書が承認されたときに、案件ステータスを自動更新する',
        default: false,
        addClass: 'checkbox-fontsize',
      }],
      checkStatus: {matter_status_update_flag: false},
      isDisabled: true
    },
    sizeX: 2,
    sizeY: 1,
    col: 2,
    row: 4,
    show: true
  }
];
export const fileUploadItemForms = FileUploadItemForm;

export const partnerSignaturePositionItemForm = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'organize_nm',
    name: 'organize_nm',
    display_id: 'organize_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様会社名',
      labelText: 'お客様会社名',
      name: 'organize_nm',
      isReadonly: true,
      isDisabled: true,
      rules: 'required',
      value: '',
      placeholder: '64文字以内',
      maxlength: 64
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 0,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_signing_name_list',
    name: 'partner_signing_name_list',
    display_id: 'partner_signing_name_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様担当者名',
      labelText: 'お客様担当者名',
      name: 'partner_signing_name_list',
      isReadonly: true,
      isDisabled: true,
      rules: 'required',
      value: '',
      placeholder: '64文字以内',
      maxlength: 64
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_signing_email_list',
    name: 'partner_signing_email_list',
    display_id: 'partner_signing_email_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様担当者メールアドレス',
      labelText: 'お客様担当者メールアドレス',
      name: 'partner_signing_email_list',
      isReadonly: true,
      isDisabled: true,
      rules: 'required|email',
      value: '',
      maxlength: 255
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_comment',
    name: 'partner_comment',
    display_id: 'partner_comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様宛送信メッセージ',
      labelText: 'お客様宛送信メッセージ',
      name: 'partner_comment',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
      placeholder: '512文字以内',
      maxlength: 512
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 2,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'thank_doc',
    name: 'thank_doc',
    display_id: 'thank_doc',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信先完了メールのメッセージ',
      labelText: '送信先完了メールのメッセージ',
      name: 'thank_doc',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
      placeholder: '128文字以内',
      maxlength: 128
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 3,
    show: true
  }
];
export const partnerSignaturePositionItemForms = partnerSignaturePositionItemForm;

export const ourSignaturePositionItemForm = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_signing_name_list',
    name: 'our_signing_name_list',
    display_id: 'our_signing_name_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者名',
      labelText: '自社署名担当者名',
      name: 'our_signing_name_list',
      isReadonly: true,
      isDisabled: true,
      rules: 'required',
      value: '',
      placeholder: '64文字以内',
      maxlength: 64
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 2,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_signing_email_list',
    name: 'our_signing_email_list',
    display_id: 'our_signing_email_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者メールアドレス',
      labelText: '自社署名担当者メールアドレス',
      name: 'our_signing_email_list',
      isReadonly: true,
      isDisabled: true,
      rules: 'required|email',
      value: '',
      maxlength: 255      
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 2,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_comment',
    name: 'our_comment',
    display_id: 'our_comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者宛送信メッセージ',
      labelText: '自社署名担当者宛送信メッセージ',
      name: 'our_comment',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
      placeholder: '512文字以内',
      maxlength: 512
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 3,
    show: true
  }
];
export const ourSignaturePositionItemForms = ourSignaturePositionItemForm;

export const contractInfomationDetailForm = [
/*  
  {
    // インタフェース利用のために必要なプロパティ、画面では未使用
    'search': false,
    'show_list': false,
    'as_title': false,
    'status': false,
    'fieldIndex': 1,
    'title_order': 1,
    'full_text': false,
    'unique': false,
    'min_value': '',
    'max_value': '',
    // ****** //
    'field_id': '契約書タイプ',
    'name': 'contractType',
    'display_id': 'contractType',
    'dataType': 'select',
    'component': 'SelectArea',
    'props': {
      'name': 'contractType',
      'label': '契約書タイプ',
      'selectData': [],
      'isDisabled': true
    },
    'sizeX':2,
    'sizeY':1,
    'col':0,
    'row':0,
    'show': true,
  },
*/  
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'document_name',
    name: 'document_name',
    display_id: 'document_name',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '文書名',
      labelText: '文書名',
      name: 'document_name',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'post_nm',
    name: 'post_nm',
    display_id: 'post_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信者部署名',
      labelText: '送信者部署名',
      name: 'post_nm',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'name_nm',
    name: 'name_nm',
    display_id: 'name_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信者名',
      labelText: '送信者名',
      name: 'name_nm',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 2,
    row: 1,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'complete_email',
    name: 'complete_email',
    display_id: 'complete_email',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '完了通知メールアドレス',
      labelText: '完了通知メールアドレス',
      name: 'complete_email',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 2,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'conclusion_date',
    name: 'conclusion_date',
    dataType: 'datetime',
    display_id: 'conclusion_date',
    component: 'DatePickerArea',
    props:{
      labelClass: 'mb-2',
      format: 'yyyy/MM/dd',
      'labelName':'契約開始日',
      'labelText':'契約開始日',
      'name':'conclusion_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 3,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'agreement_start_date',
    name: 'agreement_start_date',
    dataType: 'datetime',
    display_id: 'agreement_start_date',
    component: 'DatePickerArea',
    props:{
      labelClass: 'mb-2',
      format: 'yyyy/MM/dd',
      'labelName':'契約終了日',
      'labelText':'契約終了日',
      'name':'agreement_start_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 3,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'agreement_end_date',
    name: 'agreement_end_date',
    dataType: 'datetime',
    display_id: 'agreement_end_date',
    component: 'DatePickerArea',
    props:{
      format: 'yyyy/MM/dd',
      labelClass: 'mb-2',
      'labelName':'契約締結日',
      'labelText':'契約締結日',
      'name':'agreement_end_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 4,
    show: true
  },
/*  
  {
    // インタフェース利用のために必要なプロパティ、画面では未使用
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'contract_amount',
    name: 'contract_amount',
    display_id: 'contract_amount',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '契約金額',
      labelText: '契約金額',
      name: 'contract_amount',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: true
  },
*/  
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'long_storage',
    name: 'long_storage',
    display_id: 'long_storage',
    dataType: 'text',
    component: 'CheckBox',
    props: {
      checkBoxs: [{
        name: 'long_storage',
        text: '長期保存チェック',
        default: false,
        addClass: 'checkbox-fontsize',
      }],
      checkStatus: {long_storage: false},
      isDisabled: true
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'organize_nm',
    name: 'organize_nm',
    display_id: 'organize_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様会社名',
      labelText: 'お客様会社名',
      name: 'organize_nm',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 5,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_signing_name_list1',
    name: 'partner_signing_name_list1',
    display_id: 'partner_signing_name_list1',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様担当者名',
      labelText: 'お客様担当者名',
      name: 'partner_signing_name_list1',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 6,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_signing_email_list1',
    name: 'partner_signing_email_list1',
    display_id: 'partner_signing_email_list1',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様担当者メールアドレス',
      labelText: 'お客様担当者メールアドレス',
      name: 'partner_signing_email_list1',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 6,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_comment',
    name: 'partner_comment',
    display_id: 'partner_comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様宛送信メッセージ',
      labelText: 'お客様宛送信メッセージ',
      name: 'partner_comment',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 7,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'thank_doc',
    name: 'thank_doc',
    display_id: 'thank_doc',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信先完了メールのメッセージ',
      labelText: '送信先完了メールのメッセージ',
      name: 'thank_doc',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 8,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'access_code',
    name: 'access_code',
    display_id: 'access_code',
    dataType: 'number',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'アクセスコード',
      labelText: 'アクセスコード',
      name: 'access_code',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 9,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_signing_name_list1',
    name: 'our_signing_name_list1',
    display_id: 'our_signing_name_list1',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者名',
      labelText: '自社署名担当者名',
      name: 'our_signing_name_list1',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 10,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_signing_email_list1',
    name: 'our_signing_email_list1',
    display_id: 'our_signing_email_list1',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者メールアドレス',
      labelText: '自社署名担当者メールアドレス',
      name: 'our_signing_email_list1',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 10,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_comment',
    name: 'our_comment',
    display_id: 'our_comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者宛送信メッセージ',
      labelText: '自社署名担当者宛送信メッセージ',
      name: 'our_comment',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 11,
    show: true
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'matter_status_update_flag',
    name: 'matter_status_update_flag',
    display_id: 'matter_status_update_flag',
    dataType: 'text',
    component: 'CheckBox',
    props: {
      checkBoxs: [{
        name: 'matter_status_update_flag',
        text: 'この契約書が承認されたときに、案件ステータスを自動更新する',
        default: false,
        addClass: 'checkbox-fontsize',
      }],
      checkStatus: {matter_status_update_flag: false},
      isDisabled: false
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 11,
    show: true
  }
];
export const contractInfomationDetailForms = contractInfomationDetailForm;

export const contractInfomationConfirmForm = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    'search': false,
    'show_list': false,
    'as_title': false,
    'status': false,
    'fieldIndex': 1,
    'title_order': 1,
    'full_text': false,
    'unique': false,
    'min_value': '',
    'max_value': '',
    // ****** //
    'field_id': '契約書タイプ',
    'name': 'contractType',
    'display_id': 'contractType',
    'dataType': 'select',
    'component': 'SelectArea',
    'props': {
      'name': 'contractType',
      'label': '契約書タイプ',
      'selectData': [],
      'isDisabled': true
    },
    'sizeX':2,
    'sizeY':1,
    'col':0,
    'row':0,
    'show': false,
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'document_name',
    name: 'document_name',
    display_id: 'document_name',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '文書名',
      labelText: '文書名',
      name: 'document_name',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 1,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'post_nm',
    name: 'post_nm',
    display_id: 'post_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信者部署名',
      labelText: '送信者部署名',
      name: 'post_nm',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 1,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'name_nm',
    name: 'name_nm',
    display_id: 'name_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信者名',
      labelText: '送信者名',
      name: 'name_nm',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 2,
    row: 1,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'complete_email',
    name: 'complete_email',
    display_id: 'complete_email',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '完了通知メールアドレス',
      labelText: '完了通知メールアドレス',
      name: 'complete_email',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 2,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'conclusion_date',
    name: 'conclusion_date',
    dataType: 'datetime',
    display_id: 'conclusion_date',
    component: 'DatePickerArea',
    props:{
      labelClass: 'mb-2',
      format: 'yyyy/MM/dd',
      'labelName':'契約開始日',
      'labelText':'契約開始日',
      'name':'conclusion_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 3,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'agreement_start_date',
    name: 'agreement_start_date',
    dataType: 'datetime',
    display_id: 'agreement_start_date',
    component: 'DatePickerArea',
    props:{
      labelClass: 'mb-2',
      format: 'yyyy/MM/dd',
      'labelName':'契約終了日',
      'labelText':'契約終了日',
      'name':'agreement_start_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 3,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'agreement_end_date',
    name: 'agreement_end_date',
    dataType: 'datetime',
    display_id: 'agreement_end_date',
    component: 'DatePickerArea',
    props:{
      format: 'yyyy/MM/dd',
      labelClass: 'mb-2',
      'labelName':'契約締結日',
      'labelText':'契約締結日',
      'name':'agreement_end_date',
      'isReadonly': true,
      'isDisabled': true,
      'rules':'',
      'value': ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 4,
    show: false
  },
/*  
  {
    // インタフェース利用のために必要なプロパティ、画面では未使用
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'contract_amount',
    name: 'contract_amount',
    display_id: 'contract_amount',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '契約金額',
      labelText: '契約金額',
      name: 'contract_amount',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: false
  },
*/  
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'long_storage',
    name: 'long_storage',
    display_id: 'long_storage',
    dataType: 'text',
    component: 'CheckBox',
    props: {
      checkBoxs: [{
        name: 'long_storage',
        text: '長期保存チェック',
        default: false,
        addClass: 'checkbox-fontsize',
      }],
      checkStatus: {long_storage: false},
      isDisabled: true
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'organize_nm',
    name: 'organize_nm',
    display_id: 'organize_nm',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様会社名',
      labelText: 'お客様会社名',
      name: 'organize_nm',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 5,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_signing_name_list',
    name: 'partner_signing_name_list',
    display_id: 'partner_signing_name_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様担当者名',
      labelText: 'お客様担当者名',
      name: 'partner_signing_name_list',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 6,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_signing_email_list',
    name: 'partner_signing_email_list',
    display_id: 'partner_signing_email_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様担当者メールアドレス',
      labelText: 'お客様担当者メールアドレス',
      name: 'partner_signing_email_list',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 6,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'partner_comment',
    name: 'partner_comment',
    display_id: 'partner_comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'お客様宛送信メッセージ',
      labelText: 'お客様宛送信メッセージ',
      name: 'partner_comment',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 7,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'thank_doc',
    name: 'thank_doc',
    display_id: 'thank_doc',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '送信先完了メールのメッセージ',
      labelText: '送信先完了メールのメッセージ',
      name: 'thank_doc',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 8,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'access_code',
    name: 'access_code',
    display_id: 'access_code',
    dataType: 'number',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'アクセスコード',
      labelText: 'アクセスコード',
      name: 'access_code',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 9,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_signing_name_list',
    name: 'our_signing_name_list',
    display_id: 'our_signing_name_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者名',
      labelText: '自社署名担当者名',
      name: 'our_signing_name_list',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 10,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_signing_email_list',
    name: 'our_signing_email_list',
    display_id: 'our_signing_email_list',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者メールアドレス',
      labelText: '自社署名担当者メールアドレス',
      name: 'our_signing_email_list',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 10,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'our_comment',
    name: 'our_comment',
    display_id: 'our_comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '自社署名担当者宛送信メッセージ',
      labelText: '自社署名担当者宛送信メッセージ',
      name: 'our_comment',
      isReadonly: true,
      isDisabled: true,
      rules: '',
      value: '',
    },
    sizeX: 3,
    sizeY: 1,
    col: 0,
    row: 11,
    show: false
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'matter_status_update_flag',
    name: 'matter_status_update_flag',
    display_id: 'matter_status_update_flag',
    dataType: 'text',
    component: 'CheckBox',
    props: {
      checkBoxs: [{
        name: 'matter_status_update_flag',
        text: 'この契約書が承認されたときに、案件ステータスを自動更新する',
        default: false,
        addClass: 'checkbox-fontsize',
      }],
      checkStatus: {matter_status_update_flag: false},
      isDisabled: true
    },
    sizeX: 2,
    sizeY: 1,
    col: 2,
    row: 4,
    show: true
  },
];
export const contractInfomationConfirmForms = contractInfomationConfirmForm;
